<template>
    <div class="app-container">
        <div class="filter-container">
            <el-input clearable style="width: 200px;" class="filter-item" placeholder="功能名称" v-model="listQuery.key">
            </el-input>
            <el-select style="width: 150px" class="filter-item" v-model="listQuery.sys">
                <el-option label="全部平台" value="">
                </el-option>
                <el-option label="运营管理平台" value="PT1">
                </el-option>
                <!-- <el-option label="线索聚合平台" value="PT2">
                </el-option> -->
            </el-select>
            <el-select style="width: 150px" class="filter-item" v-model="listQuery.status">
                <el-option label="全部状态" value="99">
                </el-option>
                <el-option label="正常" value="0">
                </el-option>
                <el-option label="冻结" value="-1">
                </el-option>
            </el-select>

            <el-button class="filter-item" type="info" icon="el-icon-search" @click="doSearch">搜索</el-button>
            <el-button class="filter-item" icon="el-icon-refresh" @click="doReset">重置</el-button>
            <el-button class="filter-item" type="primary" icon="el-icon-plus" @click='showAddTab'>添加</el-button>
        </div>
        <el-table :data="list" v-loading="listLoading" fit border highlight-current-row style="width: 100%"  max-height="550">
            <el-table-column align="left" label="平台" width="180">
                <template slot-scope="scope">
                    <span>{{scope.row.sys | sysDisplay}}</span>
                </template>
            </el-table-column>

            <el-table-column align="left" label="功能名称" width="250">
                <template slot-scope="scope">
                    <span>{{scope.row.name}}</span>
                </template>
            </el-table-column>

            <el-table-column width="250px" align="left" label="路径">
                <template slot-scope="scope">
                    <span>{{scope.row.path}}</span>
                </template>
            </el-table-column>

            <el-table-column align="left" label="子功能">
                <template slot-scope="scope">
                    <span>{{scope.row.subs | subsDisplay}}</span>
                </template>
            </el-table-column>

            <!-- <el-table-column width="100px" align="center" label="排序">
                <template slot-scope="scope">
                    <span>{{scope.row.sort}}</span>
                </template>
            </el-table-column> -->

            <el-table-column class-name="status-col" align="center" label="状态" width="110">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status | statusFilter">{{scope.row.status | statusDisplay}}</el-tag>
                </template>
            </el-table-column>

            <el-table-column width="180px" align="center" label="更新时间">
                <template slot-scope="scope">
                    <span>{{scope.row.updatedAt | parseTime('{y}-{m}-{d} {h}:{i}')}}</span>
                </template>
            </el-table-column>

            <el-table-column align="center" label="操作" width="150" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" @click="toEditPage(scope.row.id)">编辑</el-button>
                    <el-button type="warning" size="mini" @click="toDelete(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

    </div>
</template>

<script>
export default {
    name: 'SystemFunctions',
    data() {
        return {
            list: null,
            total: 0,
            listLoading: false,
            listQuery: {
                page: 1,
                limit: 10,
                sys: "",
                key: "",
                status: "99"
            }
        };
    },
    filters: {
        statusFilter(status) {
            const statusMap = {
                0: "success",
                1: "info"
            };
            return statusMap[status];
        },
        statusDisplay(status) {
            const statusMap = {
                "0": "正常",
                "-1": "冻结"
            };
            return statusMap[status];
        },
        sysDisplay(sys) {
            const map = {
                "PT1": "运营管理平台",
                // "PT2": "线索聚合平台",
            };
            return map[sys];
        },
        subsDisplay(subs) {
            var result = []
            for (var i = 0; i < subs.length; i++) {
                var m = subs[i];
                result.push(m.name)
            }
            return result.join(', ')
        }
    },
    beforeRouteEnter(to, from, next) {
        if (from.path.indexOf("/functions/add") != -1 || from.path.indexOf("/functions/edit") != -1) {
            to.meta.refresh = true;
        }
        next();
    },
    activated() {
        if (this.$route.meta.hasOwnProperty("redraw") && this.$route.meta.redraw) {
            this.doReset();
            this.$route.meta.redraw = false;
        }
        if (this.$route.meta.hasOwnProperty("refresh") && this.$route.meta.refresh) {
            this.getList();
            this.$route.meta.refresh = false;
        }
    },
    created() {
        this.doReset();
    },
    methods: {
        doReset() {
            this.list = null;
            this.total = 0;
            this.listLoading = true;
            this.listQuery = {
                page: 1,
                limit: 10,
                sys: "",
                key: "",
                status: "99"
            };
            this.doSearch();
        },
        doSearch() {
            this.listQuery.page = 1
            this.getList();
        },
        getList() {
            this.listLoading = true;
            var parent = this;
            this.$httpAuth
                .post("/v1/backendFunctionRpc/list", {
                    pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
                    pageCount: this.listQuery.limit,
                    sys: this.listQuery.sys,
                    status: parseInt(this.listQuery.status),
                    key: this.listQuery.key
                })
                .then(function (response) {
                    parent.listLoading = false;
                    parent.list = response.data.data;
                    parent.total = response.data.total;
                })
                .catch(() => {
                    parent.listLoading = false;
                });
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
        showAddTab() {
            this.$router.push('/system/functions/add?' + new Date().getTime())
        },
        toEditPage(id) {
            this.$router.push('/system/functions/edit/' + id)
        },
        toDelete(id) {
            this.$confirm('是否删除该功能?', '提示', {
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var parent = this;
                this.$httpAuth
                    .post("/v1/backendFunctionRpc/delete", {
                        id: id
                    })
                    .then(function (response) {
                        parent.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        parent.getList()
                    })

            })
        }
    }
};
</script>

<style scoped>
.edit-input {
    padding-right: 100px;
}

.cancel-btn {
    position: absolute;
    right: 15px;
    top: 10px;
}
</style>
